// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26MyP","right":"styles_right__Wcx-m"};